import { FC } from "react";

interface ClockIconSVGProps {
    className?: string;
}

const ClockIconSVG: FC<ClockIconSVGProps> = (props) => {
    return (
        <svg
            className={props.className}
            width="32"
            height="33"
            viewBox="0 0 32 33"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M16.0003 8.49935V16.4993L19.3337 11.166M29.3337 16.4993C29.3337 23.8631 23.3641 29.8327 16.0003 29.8327C8.63653 29.8327 2.66699 23.8631 2.66699 16.4993C2.66699 9.13555 8.63653 3.16602 16.0003 3.16602C23.3641 3.16602 29.3337 9.13555 29.3337 16.4993Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default ClockIconSVG;
